import { toast } from 'react-toastify';

import { ITraderWallet, useRejectTraderWalletMutation } from '@entities/trades/wallet';
import { useModal } from '@shared/components/Modal';
import { isApiError } from '@shared/types/fetch-data';

interface IProps<T> {
  wallet: T;
  refetch: () => void;
}

export const RejectTraderWallet = <T extends ITraderWallet>({ wallet, refetch }: IProps<T>) => {
  const [rejectTraderWallet, { isLoading }] = useRejectTraderWalletMutation();
  const { closeModal } = useModal();

  const handleConfirm = async () => {
    const result = await rejectTraderWallet(wallet.id);

    if ('data' in result) {
      closeModal();
      refetch();
    }

    if ('error' in result && isApiError(result.error)) {
      toast.error(result.error.data.message);
    }
  };

  return (
    <div className='modal-confirm'>
      <div className='modal-confirm__title'>Reject Wallet</div>
      <div className='modal-confirm__message'>
        Are you sure you want to reject wallet #{wallet.id}? The trader will be asked to upload a
        new statement.
      </div>
      <div className='modal-confirm__btns'>
        <button disabled={isLoading} className='btn-confirm' onClick={handleConfirm}>
          Reject
        </button>
        <button type='button' className='btn-cancel secondary-btn' onClick={closeModal}>
          Cancel
        </button>
      </div>
    </div>
  );
};
